import { useCallback } from "react";

import useFetchActionbarAuth from "src/hooks/useFetchActionbarAuth";
import { useLoadingSpinnerStore } from "src/store/util/loadingSpinnerUtil";
import { downloadExcel } from "src/utils/blob/blobUtil";
import { showError, showSuccess, ShowSuccessFetch, showWarning } from "src/utils/toast/toastUtil";

import {
	downloadExcel_SAL2100_R01,
	getSAL2100_R01BrandList,
	getSAL2100_R01ItemGroupList,
	getSAL2100_R01SalesList,
} from "./Api_SAL2100_R01";
import { useSAL2100_R01Store } from "./Store_SAL2100_R01";

export const Content_SAL2100_R01 = (setMessage: (message: string) => void) => {
	const {
		SAL2100_R01Filter,
		SAL2100_R01MonthlyList,
		SAL2100_R01ItemGroupList,
		SAL2100_R01BrandList,
		setSAL2100_R01PastFilter,
		setSAL2100_R01MonthlyList,
		setSAL2100_R01ItemGroupList,
		setSAL2100_R01BrandList,
	} = useSAL2100_R01Store();
	const { setLoadingSpinner } = useLoadingSpinnerStore();

	useFetchActionbarAuth("SAL2100_R01");

	const fetchData = useCallback(async () => {
		try {
			setLoadingSpinner(true);
			const [salesResponse, itemGroupResponse, brandResponse] = await Promise.all([
				getSAL2100_R01SalesList("search", SAL2100_R01Filter),
				getSAL2100_R01ItemGroupList("search", SAL2100_R01Filter),
				getSAL2100_R01BrandList("search", SAL2100_R01Filter),
			]);
			const salesList = salesResponse.data.data.salesDtoList ?? [];
			const itemGroupList = itemGroupResponse.data.data.itemGroupDtoList ?? [];
			const brandList = brandResponse.data.data.brandDtoList ?? [];
			setSAL2100_R01MonthlyList(salesList);
			setSAL2100_R01ItemGroupList(itemGroupList);
			setSAL2100_R01BrandList(brandList);
			setSAL2100_R01PastFilter(SAL2100_R01Filter);

			const dataCount = itemGroupList.length + brandList.length;
			if (dataCount === 0) {
				showWarning("데이터가 없습니다.");
			} else {
				ShowSuccessFetch(setMessage, "조회가 완료되었습니다.");
				setTimeout(() => setMessage(""), 5000);
			}
		} catch (error) {
			console.error("SAL2100_R01 조회 실패:", error);
			showError("조회에 실패했습니다.");
		} finally {
			setLoadingSpinner(false);
		}
	}, [SAL2100_R01Filter, setLoadingSpinner, setMessage, setSAL2100_R01BrandList, setSAL2100_R01ItemGroupList, setSAL2100_R01MonthlyList, setSAL2100_R01PastFilter]);

	const handleExcelClick = useCallback(async () => {
		if (SAL2100_R01ItemGroupList.length === 0 && SAL2100_R01BrandList.length === 0) {
			showWarning("엑셀 다운로드할 데이터가 없습니다.");
			return;
		}

		try {
			setLoadingSpinner(true);
			const response = await downloadExcel_SAL2100_R01("search", SAL2100_R01Filter);
			const binaryString = atob(response.data.data);
			const byteArray = new Uint8Array(binaryString.length);
			for (let index = 0; index < binaryString.length; index++) {
				byteArray[index] = binaryString.charCodeAt(index);
			}
			downloadExcel(
				new Blob([byteArray], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }),
				"출고현황 분석.xlsx",
			);
			showSuccess("엑셀 다운로드가 완료되었습니다.");
		} catch (error) {
			console.error("SAL2100_R01 엑셀 다운로드 실패:", error);
			showError("엑셀 다운로드에 실패했습니다.");
		} finally {
			setLoadingSpinner(false);
		}
	}, [SAL2100_R01BrandList.length, SAL2100_R01Filter, SAL2100_R01ItemGroupList.length, setLoadingSpinner]);

	return { fetchData, handleExcelClick };
};
